
class RequestModel {
    id: number;
    creator: string;
    flowId: number;
    isActive: boolean;
    flowTitle: string;
    radPeygirId: string;
    radFlowId: number;
    radFirstWorkTypeId: number;
    radLastWorkTypeId: number;

    lastFlowResult: string;
    lastFlowSetting: string;
    lastFlowResultId: number;
    lastFlowSettingId: number;
    createDate: Date;
    fullName: string;
    nationalCode: string;
    constructor(
        id: number,
        creator: string,
        flowId: number,
        isActive: boolean,
        flowTitle: string,
        radPeygirId: string,
    radFlowId: number,
    radFirstWorkTypeId: number,
    radLastWorkTypeId: number,
    lastFlowResult: string,
    lastFlowSetting: string,
    lastFlowResultId: number,
    lastFlowSettingId: number,
    createDate: Date,
    fullName: string,
    nationalCode: string
    ) {
        this.id = id;
        this.creator = creator;
        this.flowId = flowId;
        this.isActive = isActive;
        this.flowTitle = flowTitle;
        this.radPeygirId = radPeygirId;
        this.radFlowId = radFlowId;
        this.radFirstWorkTypeId = radFirstWorkTypeId;
        this.radLastWorkTypeId = radLastWorkTypeId;
        this.lastFlowResult = lastFlowResult;
        this.lastFlowSetting = lastFlowSetting;
        this.lastFlowResultId = lastFlowResultId;
        this.lastFlowSettingId = lastFlowSettingId;
        this.createDate = createDate;
        this.fullName = fullName;
        this.nationalCode = nationalCode;
    }

    public static fromJson(json: any): RequestModel {
        return new RequestModel(
            json["id"],
            json["creator"],
            json["flowId"],
            json["isActive"],
            json["flowTitle"],
            json["radPeygirId"],
            json["radFlowId"],
            json["radFirstWorkTypeId"],
            json["radLastWorkTypeId"],
            json["lastFlowResult"],
            json["lastFlowSetting"],
            json["lastFlowResultId"],
            json["lastFlowSettingId"],
            json["createDate"],
            json["fullName"],
            json["nationalCode"]
        );
    }
}


export interface RequestGetPayloadFilterModel {
    id?: number;
    creator?: string;
    flowTitle?: string;
    flowId?: number;
    radPeygirId?: string;
    lastFlowSetting?: string;
    lastFlowResult?: string;
    isActive?: number;
    fullName?: string;
    nationalCode?: string;
}
export interface RequestGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: RequestGetPayloadFilterModel;
}

export interface RequestPayloadModel {
    id: number;
    flowId: number;
    radPeygirId: string;
    fullName: string;
    nationalCode: string;
    isActive: boolean;

}
export default RequestModel;
